import LocationUtilities from './utils/location-utilities';

export function enableGDPR (Freshworks, $ = jQuery) {
  // cookieConsentStatus is to track the user acceptance
  const cookieConsentStatus = localStorage.getItem('cookieConsentStatus');
  // firstVisitorNonEU is to track the user first visit in NonEU region for to fire event
  const firstVisitorNonEU = localStorage.getItem('firstVisitorNonEU');
  // This check maintains the status of user acceptance even the page refreshes
  if (cookieConsentStatus !== 'true') {
    // Initially all cookie options are opt-out only
    // Calling function to set status of the cookie
    setCookieStatus('No');
  }
  LocationUtilities.onLocationReady(function (geoLocation) {
    if (geoLocation.continent.code === 'EU' || $('.eu-extra-info.exclude-region-check').length) {
      $('.copy_write-text').slideUp(100);
      $('.eu-extra-info:not(.modal-on-click)').show();
    } else {
      $('.copy_write-text').show();
      $('.eu-extra-info .promotional-offers input').attr('checked', true);
      $('.eu-extra-info:not(.modal-on-click)').hide();
    }
    if (geoLocation.continent.code !== 'EU' && (firstVisitorNonEU === null || firstVisitorNonEU !== 'true')) {
      localStorage.setItem('firstVisitorNonEU', 'true');
    }
    if (cookieConsentStatus !== 'true') {
      setCookieStatus('No');
      $('body').on('click', '#onetrust-accept-btn-handler, #accept-recommended-btn-handler, #confirm-choices-handler, .save-preference-btn-handler', function () {
        // Had to wait a bit to let the onetrust update its variable for the user preference
        setTimeout(fireOneTrustChoiceScripts, 100);
        // setTimeout(enableGDPRCountryDropdown, 100);
      });
    }
    if (!(geoLocation.continent.code === 'EU') && ($('#non-gdpr').length > 0) && ($('#non-gdpr').is(':visible'))) {
      $(document).on('scroll', function () {
        const winHeight = $(window).height();
        const scrollPosition = $(this).scrollTop();
        const hidePoint = (winHeight * 75) / 100;
        if (scrollPosition > hidePoint) {
          $('#onetrust-accept-btn-handler').trigger('click');
          $(this).unbind('scroll');
        }
      });
    }
  });
}

/**
 * Function to enable country dropdown if an EU user doesn't give consent for functional cookies.
 */
// export function enableGDPRCountryDropdown () {
//   LocationUtilities.onLocationReady(function (geoLocation) {
//     if (
//       window.OptanonActiveGroups &&
//       !window.OptanonActiveGroups.includes('C0003')
//     ) {
//       jQuery('.gdpr-form-location').removeClass('hide');
//       return true;
//     } else {
//       jQuery('.gdpr-form-location').addClass('hide');
//       return true;
//     }
//   });
// }

const setCookieStatus = (cookieVal) => {
  localStorage.setItem('GDPRPerfCookieAllowed', cookieVal);
  localStorage.setItem('GDPRFunctionalCookieAllowed', cookieVal);
  localStorage.setItem('GDPRMarketingCookieAllowed', cookieVal);
};

const fireOneTrustChoiceScripts = () => {
  // eslint-disable-next-line no-undef
  const OptanonValues = OptanonActiveGroups || '';
  // Set local storage values based on user acceptance
  if (OptanonValues.includes('C0002')) {
    localStorage.setItem('GDPRPerfCookieAllowed', 'Yes');
  }
  if (OptanonValues.includes('C0003')) {
    localStorage.setItem('GDPRFunctionalCookieAllowed', 'Yes');
  }
  if (OptanonValues.includes('C0004')) {
    localStorage.setItem('GDPRMarketingCookieAllowed', 'Yes');
  }
  // Get the preference of the user from the local storage
  const GDPRPerfCookieAllowed = localStorage.getItem('GDPRPerfCookieAllowed');
  const GDPRFunctionalCookieAllowed = localStorage.getItem('GDPRFunctionalCookieAllowed');
  const GDPRMarketingCookieAllowed = localStorage.getItem('GDPRMarketingCookieAllowed');
  localStorage.setItem('cookieConsentStatus', 'true');
  // Add respective events to the data layer
  window.dataLayer = window.dataLayer || [];
  if (GDPRPerfCookieAllowed === 'Yes' && GDPRFunctionalCookieAllowed === 'Yes' && GDPRMarketingCookieAllowed === 'Yes') {
    window.GDPRConsentAccepted = 'yes';
    window.dataLayer.push({ event: 'GDPRConsentAccepted' });
  } else if (GDPRPerfCookieAllowed === 'No' && GDPRFunctionalCookieAllowed === 'No' && GDPRMarketingCookieAllowed === 'No') {
    window.GDPRConsentRejected = 'yes';
    window.dataLayer.push({ event: 'GDPRConsentRejected' });
  } else {
    window.GDPRConsentPartial = 'yes';
    window.dataLayer.push({ event: 'GDPRConsentPartial' });
  }
};
